import { render, staticRenderFns } from "./Getpoint.vue?vue&type=template&id=5f7b7048&scoped=true&"
import script from "./Getpoint.vue?vue&type=script&lang=js&"
export * from "./Getpoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7b7048",
  null
  
)

export default component.exports